









import Vue from 'vue'
export default Vue.extend({
    props: {
        pages: Number
    },
    mounted(){
        console.log(this.$route.fullPath);
        
    }
})
